// extracted by mini-css-extract-plugin
export default {"archiveButton":"relying-party-table-cell__archive-button__HBBzp"};